import React from "react";
import PopupComponent from "../../common/Popup";
import Input from "../../form-components/Input";

const CollectKyc = (props) => {
  return (
    <PopupComponent open={props.open} width={640}>
      <div className="m1">
        <form className="collect-kyc">
          <h3>Collect New User KYC</h3>
          <div className="v-center gap1">
            <Input label={"Pesonal name"} />
            <Input label="Contact No" />
          </div>
          <div className="v-center gap1">
            <Input label="Email Address" />
            <Input label="Company name" />
          </div>
          <div className="flex-end">
            <button className="mr1 cancel-btn" type="button">
              Cancel
            </button>
            <button className="primary-btn">Send Link</button>
          </div>
        </form>
      </div>
    </PopupComponent>
  );
};

export default CollectKyc;
